<template>
    <!-- 플랫폼, 마이페이지 -->
    <div>
        <!-- title_cont : S -->
        <MypageSubTitle/>
        <!-- title_cont : E -->
        <div class="ptc_container">
            <div class="m_tit">
                <div class="left">
                    <MypageWritingSubTitle/>
                </div>
                <div class="right">
                    <div class="search_filter_inp">
                        <select v-model="searchData">
                            <option v-for="(obj, index) in searchOptionList" :key="index" :value="obj.value" >{{obj.text}}</option>
                        </select>
                        <input  type="text" :value="searchText" @keyup="setSearchText">
                        <button type="button"></button>
                    </div>
                </div>
            </div>
            <ul class="protocol_search_list" v-if="items?.length != 0 && items">
                <li v-for="(item, i) in items">
                    <newSearchProcess v-if="tabIndex == 0" :processData="item"
                                      @goToProcessDetail="goToProcessDetail(item.processId,0)"
                                      @goToProtocolDetail="goToProtocolDetail"
                                      @goToProcessEditor="goToProcessEditor(item)"
                                      :thisMyPage = true
                    />
                </li>
            </ul>
            <NewPagination :pageCnt="page?.pageNo" :pageTotalCnt="page?.totalPages" :size="9"
                           @click="pushPage($event)"
                           v-show="!(items?.length == 0 || !items)"
            />
            <div class="search_nodata" v-if="(items?.length == 0 || !items) && !loading">
                <h3>검색 결과가 없습니다.</h3>
            </div>
        </div>
        <Loading :visible="loading"></Loading>
        <!-- container : E -->
    </div>
</template>

<script>
    import {commNewMapMutations, commNewMapActions} from "@processEditor/CommNew";
    import moment from "moment";

    import newSearchProcess from '@/components/platform_new/newSearchProcess'
    import newSearchProtocol from '@/components/platform_new/newSearchProtocol'
    import MypageSubTitle from "@/views/Platform/Account/MypageSubTitle";
    import MypageWritingSubTitle from "@/views/Platform/Account/MypageWritingSubTitle";
    import NewPagination from '@common/NewPagination.vue'
    import Loading from "@/components/common/loading.vue";

    export default {
        components: {
            newSearchProcess,
            newSearchProtocol,
            MypageSubTitle,
            MypageWritingSubTitle,
            NewPagination,
            Loading,
        },
        data() {
            return {
                category: null,
                categories: [
                    {
                        text: "공정도",
                        value: "process",
                    },
                    {
                        text: "프로토콜",
                        value: "protocol",
                    },
                ],
                items: null,
                page: null,
                loading: false,
                tabIndex: null,

                searchData: "",
                searchText: "",
                searchOptionList: [],
            };
        },
        computed: {
            user() {
                return this.$store.state.user;
            },
        },
        watch: {
            "$route.query.tabIndex"(n){
                this.tabIndex = n;
            },
            async tabIndex(n) {
                this.items = null;
                this.page = null;
                // 로그인 여부 확인.
                let userData = await await this.$wApi.user.mypage.me();
                if (userData == null || userData?.error) {
                    this.$router.push("/account/login");
                }
                
                // option setting.
                let tempSearchOptionList = [];
                if(n == 1){
                    tempSearchOptionList.push({value:"name"           , text: "프로토콜명(한글)",});
                    tempSearchOptionList.push({value:"nameEng"        , text: "프로토콜명(영문)",});
                    tempSearchOptionList.push({value:"userName"       , text: "작성자명",    });
                    tempSearchOptionList.push({value:"nodeContent"    , text: "위키내용",    });
                    tempSearchOptionList.push({value:"content"        , text: "트리 노드명", });
                    tempSearchOptionList.push({value:"nodeMemo"       , text: "메모",       });
                    tempSearchOptionList.push({value:"equipment"      , text: "장비",       });
                    tempSearchOptionList.push({value:"measurement"    , text: "측정목적",    });
                    tempSearchOptionList.push({value:"analysis"       , text: "분석목적",    });
                    tempSearchOptionList.push({value:"material"       , text: "재료",       });
                }else if(n == 0){
                    tempSearchOptionList.push({value:"name"           , text: "공정도명(한글)", });
                    tempSearchOptionList.push({value:"name_eng"       , text: "공정도명(영문)", });
                    tempSearchOptionList.push({value:"username"       , text: "작성자명",      });
                }
                this.searchOptionList = [];
                this.searchOptionList = tempSearchOptionList;
                this.searchData = this.$route.query.targetField == null ? this.searchOptionList[0].value : this.$route.query.targetField;
                this.searchText = this.$route.query.query;
                this.category = this.categories[n].value; // getList
            },
            "$route.query.pageNo"(n){
                if(n == null){ // 초기화
                    this.searchData = this.$route.query.targetField == null ? this.searchOptionList[0].value : this.$route.query.targetField;
                    this.searchText = this.$route.query.query;
                    this.getList({type: this.categories[this.$route.query.tabIndex].value});
                }
            },
            category(n) {
                this.getList({type: n});
            },
        },
        mounted() {
            this.searchText = this.$route.query.query;
            this.items = null;
            // 임의로 url 작성 후 진입시 공정도 작성목록을 조회하도록.
            if(this.$route.query?.tabIndex == null){
                this.$router.push({path :this.$route.path,query:{tabIndex:0}});
                this.tabIndex = this.$route.query.tabIndex;
            }else{
                this.tabIndex = this.$route.query.tabIndex;
            }
            this.getMe();
        },
        methods: {
            ...commNewMapActions([
                'getProtocols',
            ]),
            ...commNewMapMutations([
                'setProcessId',
            ]),
            async getMe() {
                const data = await this.$wApi.user.mypage.me();
                if (data) {
                    this.userInfo = data;
                }
            },
            pushPage(pageNo){
                const path  = this.$route.path;
                let   query = {...this.$route.query};
                query.pageNo = pageNo;
                this.$router.push({
                    path: path,
                    query: query,
                });
                query.type = this.categories[query.tabIndex].value
                this.getList({...query});
            },
            async getList({type = "process", pageNo = 1, perPage = 4, query = "",}) {
                if(this.$route.query.query != null){
                    query = this.$route.query.query;
                }
                if(this.$route.query.pageNo != null){
                    pageNo = this.$route.query.pageNo;
                }
                this.loading = true;
                this.items = null;
                let data = null;
                // process
                if (this.$route.query.tabIndex == 0) {
                    data = await this.$wApi.process.search({
                        query: query,
                        targetField: this.searchData,
                        pageNo: pageNo,
                        perPage,
                        isThumbnail: 1,
                        isProtocol: 1,
                        isMyData: 1,
                        processType: type == 'process' ? 'NORMAL' : 'ONLY_PROTOCOL',
                    });
                } else if (this.$route.query.tabIndex == 1) {
                    data = await this.$wApi.protocol.search({
                        query: query,
                        targetField: this.searchData,
                        pageNo: pageNo,
                        perPage,
                        isMyData: 1,
                        sortBy: "updatedDate, desc",
                    });
                }
                
                // console.log(data.content[0]);

                if (!data?.error) {
                    const {content, size, number, numberOfElements, totalElements, totalPages} = data;

                    this.items = content;
                    this.page = {
                        perPage: size,
                        pageNo: number + 1,
                        numberOfElements,
                        totalElements,
                        totalPages,
                    };
                    if (this.$route.query.tabIndex == 0) {
                        if(this.items?.length > 0) {
                            this.items.forEach(process => {
                                let protocols = process?.protocols;
                                if (protocols) {
                                    protocols = protocols.filter(protocol => 
                                        protocol.onlyProtocolPublicActive > 0 || protocol.showMode
                                    );
                                } else {
                                    protocols = [];
                                }
                                process.protocols = protocols;
                            });
                        }
                    }
                }
                this.loading = false;
            },
            getDate(date) {
                return moment(date).format("YYYY-MM-DD");
            },
            async goTo(category, item) {
                let protocolId = null;
                this.setProcessId(item.processId)

                if (category == 'protocol') {
                    const data = await this.getProtocols();
                    protocolId = data[0].keyOfProtocol
                }


                const {href} = this.$router.resolve({
                    path: `/${category}/editor`,
                    query: {
                        processId: item.processId,
                        editorType: category,
                        protocolId: protocolId || null,
                    }
                });
                window.open(href, '_blank');
            },
            async goToDetail(processId, tabIndex) {
                this.$router.push({
                    path: `/account/mypage/CreatedDetail`,
                    query: {
                        processId: processId,
                        tabIndex: tabIndex
                    },
                });
            },
            async goToProtocolDetail(protocolId,viewMode,tabIndex, beforeProcessId) {
                console.log("goToProtocolDetail:beforeProcessId", beforeProcessId);
                this.$router.push({
                    path: `/account/mypage/CreatedDetail`,
                    query: {
                        protocolId: protocolId,
                        viewMode: viewMode,
                        tabIndex: tabIndex,
                        beforeProcessId: beforeProcessId,
                    },
                });
            },
            async goToProcessEditor(item){
                let category = "process";
                this.setProcessId(item.processId)

                const {href} = this.$router.resolve({
                    path: `/${category}/editor`,
                    query: {
                        processId: item.processId,
                        editorType: category,
                        menuType: 'manager'
                    }
                });
                window.open(href, '_blank');
            },
            async goToProtocolEditor(item){
                let protocolId = item.protocolId;
                let keyOfProtocol = item.keyOfProtocol;
                let category = "protocol";
                this.setProcessId(item.processId)
                
                const {href} = this.$router.resolve({
                    path: `/${category}/editor`,
                    query: {
                        processId: item.processId,
                        editorType: category,
                        protocolId: protocolId,
                        keyOfProtocol: keyOfProtocol,
                    }
                });
                window.open(href, '_blank');
            },
            async goToProcessDetail(processId, tabIndex) {
                this.$router.push({
                    path: `/account/mypage/CreatedDetail`,
                    query: {
                        processId: processId,
                        tabIndex: tabIndex
                    },
                });
            },
            setSearchText(event){
                this.searchText = event.target.value;
                if (event.code === 'Enter' || event.keyCode === 13) {
                    const path  = this.$route.path;
                    let   query = {...this.$route.query};
                    query.query = this.searchText;
                    query.pageNo = 1;
                    query.targetField = this.searchData;
                    this.$router.push({
                        path: path,
                        query: query,
                    });
                    query.type = this.categories[query.tabIndex].value
                    this.getList({...query});
                }
            },
        },
    };
</script>

<style lang="scss" scoped></style>
